<template>
  <v-app class="layout-wrapper">
    <loading :active.sync="busy"/>

    <div class="mask" v-if="is_paying"></div>

    <div class="content">

      <!-- Header -->
      <header-lab name="account"></header-lab>

      <section class="list-wrapper scrollbox" v-if="!!username">

        <!-- Profile -->
        <section class="section scrollbox-content">

          <div class="section-title">
            <div>{{ $t("account.profile") }}</div>
          </div>
          <div class="section-contents">

            <!-- Username -->
            <div class="section-group">
              <div class="item">
                <span class="user-image">
                  <img v-if="user_image_existed" :src="user_image">
                  <span v-else><v-icon>mdi-account-circle</v-icon></span>
                </span>
                <span>{{ username }}</span>
              </div>
              <div class="item item-click" 
                @click="change_profile_photo_visible=true">
                {{ $t("account.manage_profile_photo") }}
              </div>
            </div>

            <!-- Email - not confirm -->
            <div class="section-group" v-if="!email_confirmed">
              <div class="item">
                <span>{{ email }}</span>
                <span class="alert">
                  <v-icon small class="red--text">mdi-alert-circle-outline</v-icon>
                </span>
              </div>
              <div class="item item-click">
                <span @click="change_email_visible=true">
                  {{ $t('change_email.change_email') }}
                </span>
                <div @click="requestConfirmEmail()">
                  {{ $t('change_email.resend_email') }}
                </div>
              </div>
            </div>
            <div class="section-group" v-if="!email_confirmed">
              <div class="item">
                <span class="alert-text">
                  {{ $t('change_email.confirm_email_text') }}
                </span>
              </div>
            </div>

            <!-- Email - confirm -->
            <div class="section-group" v-if="email_confirmed">
              <div class="item">
                <span>{{ email }}</span>
              </div>
            </div>

            <!-- Name -->
            <div class="section-group">
              <div class="item">{{ $t("account.name") }}: {{ lastname.toUpperCase() }} {{ firstname }} </div>
              <div class="item item-click"
                @click="change_name_visible=true">
                {{ $t("account.change_name") }}
              </div>
            </div>

            <!-- Password -->
            <div class="section-group">
              <div class="item">{{ $t('account.password') }}: *******</div>
              <div class="item item-click"
                @click="change_password_visible=true">
                  {{ $t('account.change_password') }}
              </div>
            </div>
          </div>
        </section>

        <hr class="horizontal-line scrollbox-content"/>

        <!-- Membership -->
        <section class="section scrollbox-content" v-if="!!user_type">
          
          <div class="section-title">
            {{ $t("account.plan_details") }}
          </div>

          <div class="section-contents">

            <div class="section-group">
              <div class="item">{{ $t("account.start_date") }}: {{ created_ts.substr(0,10) }}</div>  
            </div>

            <div class="section-group">
              <div class="item">
                <span>{{ $t('account_modal.'+user_type) }}</span>
                <span v-if="is_auto_payments&&user_type!='trial'&&user_type!='basic'">(매월)</span>
                <span v-if="!is_permanent&&user_type!='basic'">
                  <span>:</span>
                  <span>{{ $t('account_modal.to', [end_date])}}</span>
                  <span>(D-{{ date_diff }})</span>
                </span>
              </div>
              <router-link v-if="!is_permanent&&!is_cashwait&&!is_auto_payments"
                tag="div"
                class="item payment-item-click"
                :to="{ name: 'signup' }">
                {{ $t('account_modal.subscribe') }}
              </router-link>
            </div>
          </div>
        </section>

        <!-- Payment -->
        <section class="section scrollbox-content" v-if="!!user_type">
          
          <div class="section-title">
            {{ $t('account.billing_details') }}
          </div>

          <div class="section-contents">

            <div class="section-group" v-if="is_auto_payments">
              <div class="item">
                <span>{{ $t('account.premium') }}</span>
                <span>:</span>
                <span>&nbsp;{{ $t('account.monthly') }}&nbsp;{{ auto_payment.amount }}{{ $t('account.won') }}</span>
              </div>
              <div class="item">
              </div>
            </div>

            <div class="section-group" v-if="is_auto_payments">
              <div class="item">
                <span>{{ $t('account.next_payment_date') }}</span>
                <span>:</span>
                <span>&nbsp;{{ end_date }}</span>
              </div>
              <div class="item item-click"
                @click="terminate_visible=true">
                {{ $t('account.cancel_premium') }}
              </div>
            </div>

            <div class="section-group" v-if="is_auto_payments">
              <div class="item">
                <span v-if="auto_payment.pgcode=='creditcard'">
                  {{ $t('plans.card') }} {{ card_info }}
                </span>
                <span v-if="auto_payment.pgcode=='mobile'">
                  {{ $t('plans.phone') }} {{ pay_info }}
                </span>
                <span class="alert" v-if="is_auto_payments&&user_type=='basic'">
                  <v-icon small class="red--text">mdi-alert-circle-outline</v-icon>
                </span>
              </div>
              <div class="item item-click"
                @click="method_dialog=true;update_error=false">
                {{ $t('account.update_payment_info') }}
              </div>
            </div>

            <div class="section-group" v-if="is_auto_payments&&user_type=='basic'">
              <div class="item">
                <span class="alert-text">
                  {{ $t('account.alert_update_payment_info') }}
                </span>
              </div>
            </div>

            <div class="section-group" v-if="is_auto_payments&&update_error">
              <div class="item">
                <span class="alert-text">
                  {{ $t('account.alert_update_payment_error') }}
                </span>
              </div>
            </div>

            <div class="section-group">
              <div class="item"></div>  
              <div class="item item-click"
                @click="openBillingActivity()">
                  {{ $t('account.billing_details') }}
              </div>
            </div>

          </div>
        </section>

        <section class="section scrollbox-content">

          <div class="section-title">
            {{ $t("account.settings") }}
          </div>

          <div class="section-contents">

            <div class="section-group">
              <div class="item">
                <span>{{ $t("account.language") }}: {{ service_languages[language].name}}</span>
              </div>
              <div class="item-select" v-if="language=='en'||role==1">
                <v-radio-group class="small-radio" v-model="new_language" row>
                  <v-radio v-for="(value, key) in service_languages" :key="key"
                    :label="value.name"
                    :value="key">
                  </v-radio>
                </v-radio-group>
                <v-btn x-small depressed @click="changeLanguage()" 
                  :disabled="new_language==language">
                  {{ $t("account.change") }}
                </v-btn>
              </div>
            </div>

          </div>

        </section>
      </section>
      
    </div>

    <!-- Modals -->
    <modal-change-password
      :dialog.sync="change_password_visible">
    </modal-change-password>

    <modal-change-name
      :dialog.sync="change_name_visible">
    </modal-change-name>

    <modal-change-profile-photo
      :dialog.sync="change_profile_photo_visible"/>

    <modal-change-email
      :dialog.sync="change_email_visible"/>

    <modal-billing-activity
      :dialog.sync="billing_activity_visible"/>

    <modal-terminate
      :dialog.sync="terminate_visible"/>

    <!-- Email Dialog -->
    <template>
      <v-dialog v-model="email_dialog" width="400px">
        <v-card>
          <v-card-title>
            {{ $t('change_email.success') }}
          </v-card-title>
          <v-card-text>
            {{ $t('change_email.success_text') }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text @click="email_dialog=false">
              {{ $t('actions.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <!-- Update payment method -->
    <template>
      <v-dialog v-model="method_dialog" width="400px">
        <v-card>
          <v-card-title class="space-between">
            <span>{{ $t('account.update_payment_info') }}</span>
            <span><v-icon @click="method_dialog=false">close</v-icon></span>
          </v-card-title>
          <v-card-text v-if="!!is_auto_payments">
            {{ $t('account.current_payment_methods') }} :
            <span v-if="auto_payment.pgcode=='creditcard'">
              {{ $t('plans.card') }} {{ auto_payment.card_info }}
            </span>
            <span v-if="auto_payment.pgcode=='mobile'">
              {{ $t('plans.phone') }} {{ auto_payment.pay_info }}
            </span>
            {{ $t('account.alert_update_payment_1') }}
            {{ $t('account.alert_update_payment_2') }}
            <v-btn class="space-between"
              depressed block @click="updatePayment('creditcard')">
              <span>{{ $t('plans.card') }} </span>
              <span><v-icon>mdi-chevron-right</v-icon></span>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
    </template>

  </v-app>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { user_types, service_languages } from '../../../custom/model.js'
import { toDatetimeLocal, getDDay } from '../../../custom/function.js'

export default {
  metaInfo() {
    return {
      title: "Account"
    }
  },

  data() {
    return {
      user_types,
      service_languages,

      busy: false,
      is_paying: false,

      change_profile_photo_visible: false,
      change_name_visible: false,
      change_password_visible: false,
      change_email_visible: false,
      billing_activity_visible: false,
      terminate_visible: false,
      email_dialog: false,
      method_dialog: false,
      
      end_date: null,
      date_diff: null,
      new_language: null,
      card_info: null,
      pay_info: null,

      update_success: false,
      update_error: false,
    }
  },

  computed: {
    ...mapGetters({
      token_role: 'auth/token_role',
      user_image: 'user/user_image',
      user_image_existed: 'user/image_existed',
      username: 'user/username',
      lastname: 'user/lastname',
      firstname: 'user/firstname',
      email: 'user/email',
      created_ts: 'user/created_ts',
      role: 'user/role',
      status: 'user/status',
      language: 'user/language',
      is_permanent: 'user/is_permanent',
      user_type: 'user/user_type',
      user_payments: 'user/payments',
      user_auto_payments: 'user/auto_payments',
      online_url: 'payment/update_online_url',
      mobile_url: 'payment/update_mobile_url',
      order_no: 'payment/update_order_no',
    }),

    email_confirmed() {
      return this.status == 1
    },

    is_cashwait() {
      return this.user_payments.some(v => v.status == 5)
    },

    is_auto_payments() {
      return !!this.user_auto_payments ? !!this.user_auto_payments.length : false
    },

    auto_payment() {
      return !!this.user_auto_payments ? this.user_auto_payments.slice(-1).pop() : null
    },

    is_mobile() {
      return this.$isMobile()
    },
  },

  watch: {
    online_url(val) {
      if (!this.is_mobile&&!!val) {
        let vm = this
        let win = window.open(val, "", "width=450, height=600")
        // Error: 팝업창 차단
        if (win == null || typeof(win)=='undefined') {
          alert("팝업창 차단을 해제해주세요. 새로고침이 필요할 수도 있습니다.")
        }
        var close_timer = setInterval(async function() {
          if (win.closed) {
            vm.busy = true
            try {
              await vm.$store.dispatch('payment/checkRequestPayletter', {
                order_no: vm.order_no
              })
            } catch(e) {
              window.clearInterval(close_timer)
              vm.is_paying = false
              alert('에러가 발생했습니다.')
            } finally {
              let status = vm.$store.getters['payment/request_check_status']
              window.clearInterval(close_timer)
              vm.is_paying = false
              vm.busy = false
              if (status == 6) {
                alert('결제 정보 업데이트가 취소되었습니다.')
              }
              else if (status == 7) {
                vm.success = true
                vm.getMyAutoPayments()
              }
              else {
                alert('결제 정보 업데이트 중 오류가 발생했습니다. 다시 시도해주세요.')
              }
            }
          }
        }, 1000)
      }
    },

    mobile_url(val) {
      if (this.is_mobile&&!!val) {
        let vm = this
        let win = window.open(val, "_blank")
        var close_timer = setInterval(async function() {
          if (win.closed) {
            vm.busy = true
            try {
              await vm.$store.dispatch('payment/checkRequestPayletter', {
                order_no: vm.order_no
              })
            } catch(e) {
              window.clearInterval(close_timer)
              vm.is_paying = false
              alert('에러가 발생했습니다.')
            } finally {
              let status = vm.$store.getters['payment/request_check_status']
              window.clearInterval(close_timer)
              vm.is_paying = false
              vm.busy = false
              if (status == 6) {
                alert('결제 정보 업데이트가 취소되었습니다.')
              }
              else if (status == 7) {
                vm.success = true
                vm.getMyAutoPayments()
              }
              else {
                alert('결제 정보 업데이트 중 오류가 발생했습니다. 다시 시도해주세요.')
              }
            }
          }
        }, 1000)
      }
    },

    update_error(val) {
      if (val) {
        window.close()
      }
    },

    auto_payment: {
      handler(val) {
        if (!!val) {
          this.card_info = this.auto_payment.card_info
          this.pay_info = this.auto_payment.pay_info
        }
      },
      deep: true,
    },
  },

  async created() {
    this.busy = true
    this.$store.commit('payment/setUpdateOnlineURL', null)
    this.$store.commit('payment/setUpdateMobileURL', null)
    this.$store.commit('payment/setUpdateOrderNo', null)
    this.$store.commit('payment/setUpdateCheckStatus', null)
    try {
      await this.$store.dispatch('user/getUserInfo')
      await this.$store.dispatch('user/getMyAutoPayments')
    }
    catch(e) {
      this.$store.commit('error/setDialog', true)
    }
    finally {
      // Get user image
      let has_img = this.$store.getters['user/has_img']
      if (!!has_img) {
        try {
          await this.$store.dispatch('user/getUserImage')
        } catch(e) {
          this.$store.commit('error/setDialog', true)
        }
      } else {
        try {
          await this.$store.commit('user/removeUserImage')
        } catch(e) {
          this.$store.commit('error/setDialog', true)
        }
      }
      // Set end date
      let membership = this.$store.getters['user/membership']
      if (!!membership) {
        this.end_date = this.is_permanent ? null : 
          this.toDatetimeLocal(new Date(membership.end_date)).substr(0, 10)
        this.date_diff = this.getDDay(membership.end_date)
      }
      this.new_language = this.language
      this.busy = false
    }
  },

  methods: {
    toDatetimeLocal,
    getDDay,

    async requestConfirmEmail() {
      this.busy = true
      let error = false
      try {
        await this.$store.dispatch('confirm/requestConfirmEmail', {
          recipient: this.email
        })
      } catch(e) {
        this.$store.commit('error/setDialog', true)
        this.$store.commit('error/setErrorCode', e.response.status)
        error = true
      } finally {
        if (!error) {
          this.email_dialog = true
          this.$analytics.logEvent('click', { name: 'account_btn_requestConfirmEmail' })
        }
        this.busy = false
      }
    },

    async changeLanguage() {
      this.$i18n.locale = this.new_language
      try {
        await this.$store.dispatch('user/updateUserInfo', {
          language: this.new_language
        })
      } catch(e) {
        this.$store.commit('error/setDialog', true)
        this.$store.commit('error/setErrorCode', e.response.status)
      }
    },

    openBillingActivity() {
      this.$analytics.logEvent('click', { name: 'account_btn_billingActivity' })
      this.billing_activity_visible = true
    },

    async updatePayment(pgcode) {
      this.$analytics.logEvent('click', { name: 'account_btn_updatePayment' })
      this.method_dialog = false
      this.is_paying = true
      this.update_error = false
      try {
        await this.$store.dispatch('auth/updateToken')
        await this.$store.dispatch('payment/updatePayletter', {
          pgcode: pgcode,
          auto_payment_id: this.auto_payment.auto_payment_id
        })
      } catch(e) {
        this.update_error = true
      } finally {
        if (this.update_error) {
          this.is_paying = false
        }
      }
    },

    async getMyAutoPayments() {
      try {
        await this.$store.dispatch('user/getUserInfo')
        await this.$store.dispatch('user/getMyAutoPayments')
      } catch(e) {
        this.$store.commit('error/setDialog', true)
        this.$store.commit('error/setErrorCode', e.response.status)
      }
    }
  },
}
</script>

<style scoped>

  /* List */

  .list-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100vh - 60px);
    padding-top: 24px;
  }

  .section {
    width: 1000px;
    display: grid;
    grid-template-columns: 270px auto;
    padding: 0 40px;
  }

  .section-title {
    font-size: 1.4em;
    color: #999;
    font-weight: 400;
    padding: 0;
    margin-top: 15px;
    margin-bottom: 20px;
  }

  .section-contents {
    display: flex;
    flex-direction: column;
    margin-top: 15px;
    margin-bottom: 20px;
  }

  .section-group {
    display: flex;
    justify-content: space-between;
  }

  .item {
    font-size: 1.3em;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .item-click {
    color: rgb(45,92,158);
    text-decoration: none;
    cursor: pointer;
  }

  .payment-item-click {
    color: #E0457A;
    text-decoration: none;
    cursor: pointer;
  }

  .item .user-image {
    margin-right: 10px;
  }

  .user-image img {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .horizontal-line {
    border: 1px solid #D1D1D1;
  }

  .item-select {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
  }

  .item > div {
    margin-left: 12px;
  }

  .alert-text {
    font-size: 12px;
    color: #ea1d31;
  }

  /* Payment method dialog */
  .space-between {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .v-card__text .space-between {
    margin-top: 12px;
  }

  .mask {
    cursor: pointer;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(33,33,33,0.46);
    z-index: 1000;
  }

  /* Commons */

  @media only screen and (max-width: 1000px) {
    .section {
      width: 100%;
      display: flex;
      flex-direction: column;
    }

    .section-group {
      display: flex;
      flex-wrap: wrap;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/spa/common/Account.vue